<script>
    import * as ze from "@axel669/zephyr"

    import ItemInfo from "./item-info.svelte"

    let {
        nextItem = $bindable(),
        bag,
        edit = false,
    } = $props()

    const { close } = ze.modalContext()
</script>

<ze.Dialog w="min(70vw, 320px)" card>
    {#snippet header()}
        <ze.Titlebar>
            {#snippet title()}
                <ze.Text title>
                    Add Item
                    <ze.Text subtitle>
                        In: {bag.name}
                    </ze.Text>
                </ze.Text>
            {/snippet}
        </ze.Titlebar>
    {/snippet}

    <ItemInfo bind:item={nextItem} />

    {#snippet footer()}
        <ze.Grid cols="1fr 1fr">
            <ze.Button flat color="@danger" onclick={() => close(false)}>
                Cancel
            </ze.Button>
            <ze.Button flat color="@secondary" onclick={() => close(true)}>
                Add Item
            </ze.Button>
        </ze.Grid>
    {/snippet}
</ze.Dialog>
